import styled from 'styled-components'

export const LoginFormContainer = styled.div`
  .forgot-password-link {
    display: flex;
    justify-content: space-between;
    a {
      display: inline-block;
      text-align: right;
      margin: 20px 0 30px 0;
    }
  }
`

export const FormHeader = styled.div`
  display: flex;
  flex-direction: column;
  .main-logo {
    margin-bottom: 24px;
  }
`
